// Routes.jsx
import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import { AuthProvider } from "./contexts/AuthContext";
import { supabase, supabaseAdmin } from "./lib/supabase"; // ADD THIS IMPORT
import ProtectedRoute from "./components/ProtectedRoute";
import RegistrationScreen from './pages/registration-screen';
import AuditResultsScreen from './pages/audit-results-screen';
import UserDashboard from './pages/user-dashboard';
import AdminAuditManagement from './pages/admin-audit-management';
import AdminConsole from './pages/admin-console';
import InitialFormUploadScreen from './pages/initial-form-upload-screen';
import LoginScreen from './pages/login-screen';
import AdminLoginScreen from './pages/admin-login-screen';
import ProfileScreen from './pages/profile-screen';
import SettingsScreen from './pages/settings-screen';
import PaidAuditCheckoutScreen from './pages/paid-audit-checkout-screen';
import PaymentConfirmationScreen from './pages/payment-confirmation-screen';
import BillingScreen from './pages/billing-screen';
import AdminRoleVerificationScreen from './pages/admin-role-verification-screen';

const Routes = () => {
  return (
    <BrowserRouter>
      {/* Pass supabase clients as props to AuthProvider */}
      <AuthProvider supabase={supabase} supabaseAdmin={supabaseAdmin}>
        <ErrorBoundary>
          <ScrollToTop />
          <RouterRoutes>
            {/* Public routes */}
            <Route path="/login-screen" element={<LoginScreen />} />
            <Route path="/registration-screen" element={<RegistrationScreen />} />
            
            {/* Admin login - public route accessible to all */}
            <Route path="/admin-login-screen" element={<AdminLoginScreen />} />
            
            {/* Customer protected routes - admins redirected to admin console */}

            <Route path="/" element={<ProtectedRoute requireCustomer={true}><InitialFormUploadScreen /></ProtectedRoute>} />
            <Route path="/user-dashboard" element={<ProtectedRoute requireCustomer={true}><UserDashboard /></ProtectedRoute>} />
            <Route path="/initial-form-upload-screen" element={<ProtectedRoute requireCustomer={true}><InitialFormUploadScreen /></ProtectedRoute>} />
            <Route path="/audit-results-screen" element={<ProtectedRoute requireCustomer={true}><AuditResultsScreen /></ProtectedRoute>} />
            <Route path="/profile-screen" element={<ProtectedRoute requireCustomer={true}><ProfileScreen /></ProtectedRoute>} />
            <Route path="/settings-screen" element={<ProtectedRoute requireCustomer={true}><SettingsScreen /></ProtectedRoute>} />
            <Route path="/paid-audit-checkout-screen" element={<ProtectedRoute requireCustomer={true}><PaidAuditCheckoutScreen /></ProtectedRoute>} />
            <Route path="/payment-confirmation-screen" element={<ProtectedRoute requireCustomer={true}><PaymentConfirmationScreen /></ProtectedRoute>} />
            <Route path="/billing-screen" element={<ProtectedRoute requireCustomer={true}><BillingScreen /></ProtectedRoute>} />
            
            {/* Admin only routes - redirects non-admins to customer dashboard */}
            <Route path="/admin-audit-management" element={<ProtectedRoute requireAdmin={true}><AdminAuditManagement /></ProtectedRoute>} />
            <Route path="/admin-console" element={<ProtectedRoute requireAdmin={true}><AdminConsole /></ProtectedRoute>} />
            <Route path="/admin-role-verification-screen" element={<ProtectedRoute requireAdmin={true}><AdminRoleVerificationScreen /></ProtectedRoute>} />
            
            <Route path="*" element={<NotFound />} />
          </RouterRoutes>
        </ErrorBoundary>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;